export const TRANSACTIONS_ROUTE_PATH = '/transactions';
export const TRANSACTION_DETAILS_ROUTE_PATH = '/transactions/:uuid';

export const INVOICES_ROUTE_PATH = '/invoices';
export const PROPERTY_INVOICES_ROUTE_PATH = '/invoices/:propertyId';

export const INVOICE_DETAILS_ROUTE_PATH = '/invoice/:uuid';
